import { cx } from '@linaria/core';
import { useRef } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { resets } from '@ui/css';
import { generateValueId } from '@utils/common';
import { CSSRefTransition } from '@utils/react';
import { dialogCls, transitionDurationMs, dialogContentCls, focusOnContent, backdropCls } from './drawer.style.js';
import { CloseButton } from './util.close-button.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { TransitionSafeFocusOn } from '../containers/focus-on.js';

function Drawer(props) {
  const containerRef = useRef(null);
  return /*#__PURE__*/jsx(TransitionGroup, {
    component: null,
    children: props.active && /*#__PURE__*/jsx(CSSRefTransition, {
      timeout: transitionDurationMs,
      classNames: dialogCls,
      children: ref => /*#__PURE__*/jsxs("dialog", {
        ref: ref,
        open: props.active,
        className: cx(resets.rootCls, dialogCls, props.className),
        children: [/*#__PURE__*/jsx(TransitionSafeFocusOn, {
          transitionEnterDuration: transitionDurationMs,
          onEscapeKey: props.onClose,
          onClickOutside: props.onClose,
          scrollLock: true,
          focusLock: true,
          allowPinchZoom: true,
          autoFocus: true,
          preventScrollOnFocus: true,
          children: /*#__PURE__*/jsxs("div", {
            className: dialogContentCls,
            children: [/*#__PURE__*/jsx("div", {
              className: focusOnContent
              // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
              ,
              tabIndex: 0,
              ref: containerRef,
              children: props.children
            }), /*#__PURE__*/jsx(CloseButton, {
              onClose: props.onClose,
              label: "Luk panel"
            })]
          })
        }), !props.disableBackdrop && /*#__PURE__*/jsx("div", {
          className: backdropCls
        })]
      })
    }, props.explicitKey ?? generateValueId(props.children))
  });
}

export { Drawer };
//# sourceMappingURL=drawer.js.map
